import React from 'react';
import times from 'helpers/utils';
import Style from './EPGLoader.module.scss';

const renderGrid = i => (
  <div className={Style.gridRow} key={i}>
    <div className={Style.left} />
    <div className={Style.right} />
  </div>
);

const EPGLoader = () => (
  <div className={Style.epgLoader}>
    <section className={Style.epgWrap}>{times(10, renderGrid)}</section>
  </div>
);

export default EPGLoader;
